/* section-cart.js — extracted from sections/cart.liquid */
const CART_DATAEl = document.getElementById('cart-data');
const CART_DATA = CART_DATAEl ? JSON.parse(CART_DATAEl.textContent) : {};
const FREE_SHIPPING_LIMIT = CART_DATA.freeShippingThreshold; // in cents

  async function updateCartItemQuantity(key, newQty) {
    newQty = parseInt(newQty, 10);
    if (isNaN(newQty) || newQty < 0) newQty = 0;

    try {
      const res = await fetch(window.themeRoutes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      });

      const updatedCart = await res.json();
      renderCartPageLive(updatedCart);
    } catch (err) {
      console.error('Error updating cart quantity:', err);
    }
  }

  function renderCartPageLive(cart) {
    // 1. Update count headers & badges
    const headerCount = document.getElementById('cart-header-count');
    const siteCartCounts = document.querySelectorAll('#site-cart-count, #desktop-cart-count, #mobile-cart-count, .header-bag-count, .cart-count-badge');
    
    if (headerCount) headerCount.textContent = cart.item_count;
    siteCartCounts.forEach(el => {
      if (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      }
    });

    // 2. Empty state check
    const emptyView = document.getElementById('cart-empty-state-view');
    const mainGridView = document.getElementById('cart-main-grid-view');

    if (cart.item_count === 0) {
      if (emptyView) emptyView.style.display = 'flex';
      if (mainGridView) mainGridView.style.display = 'none';
      if (typeof renderBottomCartBar === 'function') renderBottomCartBar(cart);
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      return;
    }

    if (emptyView) emptyView.style.display = 'none';
    if (mainGridView) mainGridView.style.display = 'grid';

    // 3. Update Free Shipping Tracker
    const remaining = FREE_SHIPPING_LIMIT - cart.total_price;
    const percent = Math.min(100, Math.max(0, (cart.total_price / FREE_SHIPPING_LIMIT) * 100));
    const deliveryText = document.getElementById('cart-free-delivery-text');
    const deliveryFill = document.getElementById('cart-delivery-fill');

    if (deliveryFill) deliveryFill.style.width = `${percent}%`;
    const formatCartPrice = (cents) => window.theme.formatMoney(cents);

    if (deliveryText) {
      if (remaining <= 0) {
        deliveryText.textContent = window.themeStrings.freeShippingSuccess;
      } else {
        const remFmt = formatCartPrice(remaining);
        deliveryText.innerHTML = window.themeStrings.freeShippingProgress.replace('@@AMOUNT@@', remFmt);
      }
    }

    // 4. Update Summary Totals
    const formattedTotal = formatCartPrice(cart.total_price);
    const subtotalEl = document.getElementById('cart-summary-subtotal');
    const totalEl = document.getElementById('cart-summary-total');
    const priceTagEl = document.getElementById('cart-checkout-price-tag');
    const shippingEl = document.getElementById('cart-summary-shipping');

    /* Money can carry markup. Currency apps ask merchants to set the money
     format to <span class=money>{{amount}}</span> so they can find and
     convert prices, so anything built from shop.money_format or the money
     filter has to be written as HTML - textContent would escape the span
     and print the tags on the page. The value is a shop setting plus a
     number this theme formatted, never shopper input. */
    if (subtotalEl) subtotalEl.innerHTML = formattedTotal;
    if (totalEl) totalEl.innerHTML = formattedTotal;
    if (priceTagEl) priceTagEl.innerHTML = `&bull; ${formattedTotal}`;
    if (shippingEl) {
      shippingEl.innerHTML = remaining <= 0
        ? `<strong>${window.themeStrings.free}</strong>`
        : window.themeStrings.calculatedAtCheckout;
    }

    // 5. Render Line Items
    const container = document.getElementById('cart-items-list-container');
    if (container && cart.items) {
      container.innerHTML = cart.items.map(item => {
        const unitPrice = formatCartPrice(item.final_price);
        const origPrice = item.original_price > item.final_price ? formatCartPrice(item.original_price) : null;

        return `
          <div class="cart-item-row" data-line-key="${item.key}" data-product-id="${item.product_id}">
            <button
              type="button"
              class="cart-item-remove-trigger"
              onclick="updateCartItemQuantity('${item.key}', 0)"
              aria-label="Remove item"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>

            <a href="${item.url}" class="cart-item-image-wrap">
              <img src="${item.featured_image ? item.featured_image.url : ''}" alt="${item.title}" class="cart-item-img" width="220" height="293">
            </a>

            <div class="cart-item-info">
              <div class="cart-item-top-row">
                <h3 class="cart-item-heading">
                  <a href="${item.url}" class="cart-item-heading-link">${item.product_title.toUpperCase()}</a>
                </h3>
              </div>

              ${item.variant_title ? `
                <div class="cart-item-variant-details">
                  <span class="cart-item-variant-chip">VARIANT: <strong>${item.variant_title.toUpperCase()}</strong></span>
                </div>
              ` : ''}

              <div class="cart-item-price-row">
                <span class="cart-item-unit-price">${unitPrice}</span>
                ${origPrice ? `<span class="cart-item-compare-price">${origPrice}</span>` : ''}
              </div>

              <div class="cart-item-bottom-controls flex-between align-center">
                <div class="cart-item-qty-box flex align-center">
                  <button
                    type="button"
                    class="cart-qty-btn cart-qty-minus"
                    onclick="updateCartItemQuantity('${item.key}', ${item.quantity - 1})"
                  >-</button>
                  <input
                    type="number"
                    value="${item.quantity}"
                    min="0"
                    class="cart-qty-input"
                    onchange="updateCartItemQuantity('${item.key}', this.value)"
                  >
                  <button
                    type="button"
                    class="cart-qty-btn cart-qty-plus"
                    onclick="updateCartItemQuantity('${item.key}', ${item.quantity + 1})"
                  >+</button>
                </div>

                <a href="${item.url}" class="cart-item-view-btn">
                  ${window.themeStrings.viewProduct}
                </a>
              </div>
            </div>
          </div>
        `;
      }).join('');
    }

    // 6. Broadcast cart update & sync with desktop bottom bar
    if (typeof renderBottomCartBar === 'function') {
      renderBottomCartBar(cart);
    }
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  }
